export default "__VITE_ASSET__Ch3xj1Rm__"